(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/collections/activegames.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/collections/activegames.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.collections.ActiveGames = Backbone.Collection.extend({
    model: Backbone.Model.extend({
      idAttribute: 'id',

      defaults: {
        icon: undefined,
        id: 0,
        name: undefined,
        lastWinTS: undefined,
        price: undefined,
        prio: undefined,
        backgroundImageLarge: undefined,
        textRows: undefined,
        theme: 'inverted',
        buttons: undefined,
        moneyRain: false,
        responsiveTextRows: true,
        infoBar: undefined,
        disabled: true,
        secondsLeft: undefined,
        jackpot: undefined,
        jacpotText: undefined
      },

      initialize: function() {
        var self = this;
        this.get('infoBar').on('change:date', function() {
          self.trigger('change:date', self);
        });
        this.get('infoBar').on('change:price', function() {
          self.trigger('change:price', self);
        });
        this.get('infoBar').on('change:users', function() {
          self.trigger('change:users', self);
        });
        this.on(
          'change:lastWinTS',
          function() {
            this.trigger('alert', 'BINGO!');
          },
          this
        );
      },

      parse: function(data) {
        var self = this;

        return {
          jackpot: data.jackpotvalue,
          jackpotText:
            'Jackpot: ' + svs.utils.format.Currency(data.jackpotvalue),
          icon: data.icon,
          id: +data.id,
          name: data.name,
          lastWinTS: data.lastWinTS,
          price: data.price,
          pprio: +data.pprio,
          backgroundImageLarge: data.backgroundImageLarge,
          textRows: [
            '',
            data.name,
            data.jackpotvalue
              ? 'Jackpot: ' +
                svs.utils.format.Currency(data.jackpotvalue) +
                ' kr'
              : '',
            data.modelt
          ],
          buttons: [
            {
              label: 'Spela ' + data.name,
              callback: function() {
                self.trigger(
                  'navigate',
                  self.get('id'),
                  self.get('disabled'),
                  self.get('name')
                );
              }
            }
          ],
          moneyRain: data.moneyrain,
          infoBar: new (Backbone.Model.extend({
            defaults: {
              price: data.price,
              users: +data.players,
              date: data.date
            }
          }))(),
          disabled: data.disabled,
          secondsLeft: data.secondsLeft,
          playmode: data.playmode,
          hasChatHost: data.chatrooms.split(':')[2] !== '0'
        };
      }
    })
  });
})(Backbone, _, svs);


 })(window);